import { useEffect } from 'react';

import { useGetLimuloPartiteInCorsoQuery } from '@/services/limuloApi';
import { useLimuloPolling, useLimuloPollingGuida } from '@/hooks/useLimuloPolling';
import { useEverFailed } from '@/hooks/useStalled';
import { LIMULO_POLL_LIVE_MS } from '@/lib/limulo/polling';
import type { LimuloPartiteLive } from '@/types/limulo';

/**
 * Il RACCOGLITORE della Live CR su Limulo (I-224): un componente SENZA disegno per gioco CR, che legge
 * e riporta su. Un componente per lettura tiene gli hook di RTK Query statici (niente hook in un
 * ciclo) e isola il guasto di UN gioco dagli altri.
 * Lotto 2 di L-2315 (a): una lettura sola per gioco, `GET /v1/tournaments/live-matches`. Il lotto 1
 * ne aveva due tipi (i tornei in corso, poi il tabellone di ciascuno): e' in #459.
 * ⚠️ Resta montato anche quando non c'e' niente da mostrare: smontato con la lista, la scheda
 * smetterebbe di accorgersi che una partita e' cominciata.
 */

/** Cio' che un raccoglitore riporta: i dati (se sono arrivati) e i due segnali MONOTONI del verdetto. */
export interface LetturaLive<T> {
  readonly data: T | undefined;
  /** `data !== undefined`: non lampeggia sotto polling (v. `lib/listState.ts`). */
  readonly risposto: boolean;
  /** `useEverFailed`: una lettura fallita resta fallita finche' non risponde. */
  readonly fallito: boolean;
}

export function PartiteInCorsoDelGioco({
  gameId,
  onLettura,
}: {
  gameId: string;
  onLettura: (gameId: string, lettura: LetturaLive<LimuloPartiteLive>) => void;
}) {
  const polling = useLimuloPolling();
  const q = useGetLimuloPartiteInCorsoQuery({ gameId }, polling.ritmo);
  useLimuloPollingGuida(polling, q, LIMULO_POLL_LIVE_MS);
  const risposto = q.data !== undefined;
  const fallito = useEverFailed(q.isError, risposto);
  useEffect(() => {
    onLettura(gameId, { data: q.data, risposto, fallito });
  }, [gameId, q.data, risposto, fallito, onLettura]);
  return null;
}
